import { css } from '@lastbrand/web-ui-styled-system/css'

import { optionBoxRecipe, optionColumnClass, redDotClass } from './option-selector-shared.styles'

/**
 * DS twin of `imageOption.module.scss`. Two label shapes: rectangular (default)
 * and round (`isRound`); both darken their border on selection via the shared
 * `optionBoxRecipe`. Off-grid sizes are kept literal px (flagged: no-token).
 */
export { optionColumnClass as imageOptionWrapperClass, redDotClass }

export const imageLabelClass = css(optionBoxRecipe.raw(), {
  // 60×40px swatch; px literal (no size token).
  width: '60px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '8px 18px',
})

export const imageLabelRoundClass = css(optionBoxRecipe.raw(), {
  boxSizing: 'content-box',
  borderRadius: 'radius-round',
  width: '20px',
  height: '20px',
  padding: '4px',
  // round variant's resting border is transparent (only the selected darken shows).
  borderColor: 'transparent',
})

export const imageClass = css({
  width: '100%',
  height: '100%',
})

export const imageRoundInnerClass = css({
  borderWidth: '1px',
  borderStyle: 'solid',
  // parity: legacy swatch ring `rgba(black, 0.2)` → closest token `lightgray`.
  borderColor: 'lightgray',
  borderRadius: 'radius-round',
})
